import { Injector, Pipe, PipeTransform, Type } from '@angular/core';

@Pipe({
	name: 'dynamicPipe',
	pure: false,
	standalone: false,
})
/** A pipe that can dynamically apply another pipe based on the provided type. Useful for scenarios where the pipe to be used is determined at runtime. */
export class DynamicPipeComponent implements PipeTransform {
	constructor(private injector: Injector) {}

	private pipe: PipeTransform | null = null;

	transform(value: string, pipe: Type<PipeTransform>, args?: any[]): string {
		if (!this.pipe || this.pipe.constructor !== pipe) {
			this.pipe = this.injector.get(pipe);

			if (!this.pipe) {
				this.pipe = new (pipe as any)() as PipeTransform;
			}
		}
		return this.pipe ? this.pipe.transform(value, ...(args || [])) : value;
	}
}
